/**
 * Created by Ram on 14/09/2016.
 */

import React, { useContext } from 'react';
import jwt from "jsonwebtoken";
import { Link, navigate } from '@reach/router'
import { AuthenticationContext } from '../contexts/authentication-context'
import { getRegionNameFromEnvVariables } from '../../services/helpers'
import Logo from './logo'
import HeaderButton from './header-button';

const Header = () => {
    const { setIsUserAuthenticated } = useContext(AuthenticationContext)

    const handleSignOut = () => {
        localStorage.clear()
        setIsUserAuthenticated(false)
        navigate('/login', { replace: true })
    };

    let welcomeUser = null;
    const idToken = localStorage.getItem("idToken")

    if (idToken) {
        let username = jwt.decode(idToken).email;
        username = username.substr(0, username.indexOf('@'));
        welcomeUser = "Welcome " + username;
    }

    return (
        <div className="navbar navbar-default navbar-fixed-top">
            <div className="container-fluid top-nav-margin BlueConnectHeader">
                <div className="navbar-header BlueConnectHeaderLogo">
                    <Link to='/'>
                        <div className="portalLogo">
                            <Logo />
                            <h4>- {getRegionNameFromEnvVariables()}</h4>
                        </div>
                    </Link>
                </div>

                <div className="BlueConnectHeaderMessage">
                    <span>{welcomeUser}</span>

                    <div className="nav navbar-nav navbar-right adminHeaderDetails">
                        <HeaderButton onClick={handleSignOut} displayText="Sign Out" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;
